import { Link } from "react-router-dom";
import "./index.css";
import React from "react";

export const BackButton = () => {
  return (
    <div
      className={"backButton"}
      onClick={() => (window.location.href = "/")}
    >
      <Link to={"/"}>
        <span>Back to home</span>
      </Link>
    </div>
  );
};
